/**
 * Parses document.referrer into a structured traffic source.
 * Used to classify visitors as organic, social, direct, etc.
 */
export function parseReferrer(referrer) {
  if (!referrer) return { source: 'direct', medium: 'none' };

  let hostname;
  try {
    hostname = new URL(referrer).hostname.toLowerCase();
  } catch {
    return { source: 'unknown', medium: 'referral' };
  }

  const aiProvider = detectAiProvider(null, referrer);
  if (aiProvider) return { source: aiProvider, medium: 'ai' };

  // Search engines
  if (hostname.includes('google.')) return { source: 'google', medium: 'organic' };
  if (hostname.includes('bing.')) return { source: 'bing', medium: 'organic' };
  if (hostname.includes('yahoo.')) return { source: 'yahoo', medium: 'organic' };
  if (hostname.includes('duckduckgo.')) return { source: 'duckduckgo', medium: 'organic' };
  if (hostname.includes('baidu.')) return { source: 'baidu', medium: 'organic' };
  if (hostname.includes('yandex.')) return { source: 'yandex', medium: 'organic' };

  // Social
  if (hostname.includes('facebook.') || hostname.includes('fb.com'))
    return { source: 'facebook', medium: 'social' };
  if (hostname.includes('instagram.')) return { source: 'instagram', medium: 'social' };
  if (hostname.includes('twitter.') || hostname.includes('x.com'))
    return { source: 'twitter', medium: 'social' };
  if (hostname.includes('tiktok.')) return { source: 'tiktok', medium: 'social' };
  if (hostname.includes('linkedin.')) return { source: 'linkedin', medium: 'social' };
  if (hostname.includes('pinterest.')) return { source: 'pinterest', medium: 'social' };
  if (hostname.includes('whatsapp.') || hostname.includes('wa.me'))
    return { source: 'whatsapp', medium: 'social' };
  if (hostname.includes('t.me') || hostname.includes('telegram.'))
    return { source: 'telegram', medium: 'social' };

  // Agora properties (internal)
  if (hostname.includes('agora.red')) return { source: 'agora', medium: 'internal' };

  return { source: hostname, medium: 'referral' };
}

const AI_SOURCES = {
  chatgpt: 'chatgpt',
  openai: 'chatgpt',
  claude: 'claude',
  anthropic: 'claude',
  perplexity: 'perplexity',
  gemini: 'gemini',
  copilot: 'copilot'
};

export function detectAiProvider(utmSource, referrer) {
  const source = String(utmSource || '')
    .trim()
    .toLowerCase();
  if (AI_SOURCES[source]) return AI_SOURCES[source];
  if (!referrer) return null;
  try {
    const hostname = new URL(referrer).hostname.toLowerCase();
    if (/^(chat\.openai|chatgpt)\.com$/.test(hostname)) return 'chatgpt';
    if (/(^|\.)claude\.ai$/.test(hostname)) return 'claude';
    if (/(^|\.)perplexity\.ai$/.test(hostname)) return 'perplexity';
    if (/^gemini\.google\.com$/.test(hostname)) return 'gemini';
    if (/^copilot\.microsoft\.com$/.test(hostname)) return 'copilot';
    return null;
  } catch {
    return null;
  }
}
